import React, { useEffect } from "react";
import { apiDomain, systemCode } from "../..";
import { getAccountIds, getLocalhostLocatiohHref, getUrlToFetch, loadSessionToken } from "../../data/utils";



export default function XPromoPanel(props) {
    const localHostLocationHref = getLocalhostLocatiohHref();

    function isXPromoCardReady() {
      return typeof(card) == 'object'  && typeof(eval('card')?.render) != 'undefined';
    }

    useEffect(() => {
        const xhttp = new XMLHttpRequest();
        const id = "xpromo-panel";
        let container = document.getElementById(id);

        xhttp.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {
              
              if (!container) {
                container = document.createElement('div');
                container.setAttribute("id", id)
                document.body.appendChild(container);
              }
        
              container.innerHTML = this.response;
        
              if(!window.xs_xpromo_panel_loaded) {
                Array.from(container.querySelectorAll("script")).forEach(oldScript => {
                  if(oldScript.hasAttribute("src")) {
                    const newScript = document.createElement("script");
                    Array.from(oldScript.attributes)
                      .forEach(attr => newScript.setAttribute(attr.name, attr.value));
                    newScript.async = false;
                    newScript.appendChild(document.createTextNode(oldScript.innerHTML));
                    if(localHostLocationHref && oldScript.src){
                      newScript.src = oldScript.src.replace(localHostLocationHref,apiDomain || localHostLocationHref);
                    }
                    if(oldScript.parentNode){
                        oldScript.parentNode.replaceChild(newScript, oldScript);
                    }
                  }
                }); 

                const interval = setInterval(() => {
                  if(isXPromoCardReady()) {
                    clearInterval(interval);
                    window.xs_xpromo_panel_loaded = true; 
                  }
                }, 100);  
                
              }

              const interval = setInterval(() => {
                
                if(isXPromoCardReady()) {
                  clearInterval(interval);
                  Array.from(container.querySelectorAll("script")).forEach(oldScript => {
                    if(!oldScript.hasAttribute("src")) {
                      const newScript = document.createElement("script");
                      Array.from(oldScript.attributes)
                        .forEach(attr => newScript.setAttribute(attr.name, attr.value));
                      newScript.async = false;
                      newScript.appendChild(document.createTextNode(oldScript.innerHTML));
                      if(localHostLocationHref && oldScript.src){
                        newScript.src = oldScript.src.replace(localHostLocationHref,apiDomain || localHostLocationHref);
                      }
                      if(oldScript.parentNode){
                          oldScript.parentNode.replaceChild(newScript, oldScript);
                      }
                    }
                  });  
                  
                }
                
              }, 100);

              if(localHostLocationHref){
                  Array.from(container.querySelectorAll("link")).forEach(oldCss => {
                      const newCss = document.createElement("link");
                      Array.from(oldCss.attributes)
                      .forEach(attr => newCss.setAttribute(attr.name, attr.value));
                      newCss.async = false;
                      newCss.appendChild(document.createTextNode(oldCss.innerHTML));
                      if(oldCss.href){
                          newCss.href = oldCss.href.replace(localHostLocationHref,apiDomain || localHostLocationHref);
                      }
                      if(oldCss.parentNode){
                          oldCss.parentNode.replaceChild(newCss, oldCss);

                      }
                  });
              }
            }
          };
          
          const idConto = getAccountIds()?.split(";")?.[0] || '';
          const urlToFetch = getUrlToFetch('/XPromo/getPromo');
          const params = "system_code="+systemCode+"&product_id=1"+"&device_id=1"+"&id_conto="+idConto+"&user_token="+loadSessionToken();
          xhttp.open("GET",urlToFetch+'?'+params, true);
          xhttp.send();

    }, []);

    return (
        <>
            <div id="xpromo-panel" ></div>
        </>
    )
}